/** Shared desktop header height for dashboard shell and trade page navbar. */
export const APP_SHELL_HEADER_HEIGHT = 56;
